export default "__VITE_ASSET__8a9ed4d9__"